const { Criteria } = Shopware.Data

Shopware.Component.override('sw-category-detail', {
    computed: {
        // Add zeoProductUpsellings relation to the criteria to ensure the relation is loaded
        categoryCriteria() {
            const criteria = this.$super('categoryCriteria')

            criteria
                .getAssociation('zeoCategoryUpsellings')
                .addSorting(Criteria.sort('position', 'ASC'))

            criteria
                .getAssociation(
                    'zeoCategoryUpsellings.upsellingAssignedProducts'
                )
                .addSorting(Criteria.sort('position', 'ASC'))
                .addAssociation('product')
                .getAssociation('product')
                .addAssociation('options.group')

            return criteria
        }
    }
})
